import { MenuItem, VueRouter } from "@abaco/web-common/src/app";

export function createMenu(router: VueRouter): MenuItem[] {
    return [
        {
            id: "horta-reserved-area",
            descrKey: "horta-reserved-area",
            icon: "far fa-at",
            onClick: () => router.push({ name: "reserved-area" }),
            get isVisible() {
                return true;
            }
        },
    ];
}

